import Helper from './Helper';

class NoHeader {
  constructor() {
    const body = document.querySelector('body');
    this.headerBg = document.querySelector('.ns-img--bg-header');
    this.video = document.querySelector('.ns-video--header');
    this.videoHero = document.querySelector('.ns-hero-video');

    if ( this.headerBg == null && this.video == null && this.videoHero == null ) {
      Helper.addClass(body, 'no-header');
    } else if ( (this.headerBg != null || this.video != null  || this.videoHero  != null ) && body.classList.contains("no-header") ) {
      Helper.removeClass(body, 'no-header');
    }
  }
}
export default NoHeader;
